/**
 * Audit ingest client — invoke edge function (pull fallback: fetch + map + persist).
 * Primary path is Doug's push to the same edge function; this client call is
 * Mapping and DB writes live in supabase/functions/ruby-ai-ingest-authority44.
 */

import { supabase } from "@/lib/supabaseClient";
import { normalizeDomain } from "./siteService";

const EDGE_FUNCTION = "ruby-ai-ingest-authority44";

export interface Authority44MappedResponse {
  success: boolean;
  domain?: string;
  region?: string;
  processingTime?: number;
  report_id?: string;
  claimed?: boolean;
  already_imported?: boolean;
  cardsPopulated?: string[];
  error?: string;
  message?: string;
  sources?: {
    authority44?: boolean;
  };
}

/** Invoke ingest edge function — server persists to card_audit_results. */
export async function ingestAuthority44Audit(
  domain: string,
  region = "au"
): Promise<Authority44MappedResponse> {
  const cleanDomain = normalizeDomain(domain);
  if (!cleanDomain) {
    return { success: false, error: "Invalid domain" };
  }

  const { data, error } = await supabase.functions.invoke(EDGE_FUNCTION, {
    body: { domain: cleanDomain, region },
  });

  if (error) {
    console.error("[audit-ingest] Fetch error:", error.message);
    return { success: false, error: error.message };
  }

  if (!data?.success) {
    return {
      success: false,
      error: data?.error || "Audit import failed",
    };
  }

  const cardsPopulated = data.cardsPopulated || [];
  return {
    success: true,
    domain: data.domain || cleanDomain,
    region: data.region || region,
    processingTime: data.processingTime,
    report_id: data.report_id,
    claimed: data.claimed,
    already_imported: data.already_imported,
    cardsPopulated,
    message: data.already_imported
      ? `Report ${data.report_id} already imported.`
      : `Imported actions across ${cardsPopulated.length} Smart Cards.`,
    sources: data.sources,
  };
}
